import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
//import store from './store'

//import Vuex from 'vuex'
import { createStore } from 'vuex'

// Create a new store instance.
const store = createStore({
    state () {
        return {
            //count: 0,
            //token: "",
            UserInfo: {
                token: "",
            },
            MessaggioGlobale: {
                mostraMessaggio: "",
                alertMessaggio: [""],
                alertClass: "",     
                alertIcon: "",
                alertIconSpin: false,
            }
        }
    },
    mutations: {
        UserInfo (state, o) {
          state.UserInfo = o
        },
        token (state, t) {
            state.UserInfo.token = t
        },
        Messaggio (state, o) {
            state.MessaggioGlobale.mostraMessaggio= o.parms[0];
            state.MessaggioGlobale.alertMessaggio = o.parms[1];
            state.MessaggioGlobale.alertClass= o.parms[2];     
            state.MessaggioGlobale.alertIcon =  o.parms[3];
            state.MessaggioGlobale.alertIconSpin = o.parms[4];
            if(o.parms[5]>0) {
                window.setTimeout(() => {
                    state.MessaggioGlobale.mostraMessaggio= false;
                }, o.parms[5] )
            }
        },


    }
})

/* import specific icons */
import { faHouse, faComments, faPlusCircle, faMinusCircle, faPlus, faMinus, faUser, faSearch, faSpinner, 
    faUsers, faLock, faLockOpen, faXmark, faCircleLeft, faEdit, faCircle, faCheck, faTrash, faBold, faItalic, faFaceSmile,
    faStar, faTv, faPaperPlane, faFloppyDisk, faTableCells, faArrowDownShortWide, faInfo, faCog, faEye, faCalendarDays, faCalendarCheck,
    faVideo, faPaperclip, faArrowUpRightFromSquare, faTableList, faFileExcel, faStop, faCopy, faStamp } from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(faHouse)
library.add(faComments)
library.add(faUser)
library.add(faSearch)
library.add(faSpinner)
library.add(faUsers)
library.add(faLock)
library.add(faLockOpen)
library.add(faXmark)
library.add(faPlusCircle)
library.add(faMinusCircle)
library.add(faPlus)
library.add(faMinus)
library.add(faCircleLeft)
library.add(faEdit)
library.add(faCircle)
library.add(faCheck)
library.add(faTrash)
library.add(faBold)
library.add(faItalic)
library.add(faFaceSmile)
library.add(faStar)
library.add(faTv)
library.add(faPaperPlane)
library.add(faFloppyDisk)
library.add(faTableCells)
library.add(faArrowDownShortWide)
library.add(faInfo)
library.add(faCog)
library.add(faEye)
library.add(faCalendarDays)
library.add(faCalendarCheck)
library.add(faVideo)
library.add(faPaperclip)
library.add(faArrowUpRightFromSquare)
library.add(faTableList)
library.add(faFileExcel)
library.add(faStop)
library.add(faCopy)
library.add(faStamp)

//createApp(App).use(store).use(router).mount('#app')


// Carica la configurazione e poi monta l'app
fetch(process.env.BASE_URL + "config.json")
  .then((response) => response.json())
  .then((config) => {
    // either use window.config
    //window.config = config
    // or use [Vue Global Config][1]
    //App.config.globalProperties.config = config
    // FINALLY, mount the app
    createApp(App).use(router).use(store).component('font-awesome-icon', FontAwesomeIcon).provide("cfg", config).mount('#app')
    
            
    //App.mount("#app")
  })
